// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"8001":"css/admin-app.6948","8645":"css/app.6948"}[chunkId] + ".css";
};